import React from 'react'
import { PROMO_TYPE_VARIANT } from '../../../api/marketing/promoScheduleConstants'
import './PromoTypeBadge.sass'

const VARIANT_CLASS_MAP = {
  [PROMO_TYPE_VARIANT.brandOffer]: 'PromoTypeBadge_brandOffer',
  [PROMO_TYPE_VARIANT.ame]: 'PromoTypeBadge_ame',
}

function PromoTypeBadge({ variant, label }) {
  const variantClass = VARIANT_CLASS_MAP[variant] || 'PromoTypeBadge_ame'

  return <span className={`PromoTypeBadge ${variantClass}`.trim()}>{label || '—'}</span>
}

export default PromoTypeBadge
